import {useQuery} from 'react-query';
import getUserCooperationAgreementData from './getUserCooperationAgreementData';

interface IProps {
  enabled?: boolean;
  onSuccess?: () => void;
}

const useGetUserCooperationAgreementData = (props?: IProps) => {
  const {data, isLoading} = useQuery(
    ['get-cooperation-agreement-data'],
    () => getUserCooperationAgreementData(),
    {
      enabled: props?.enabled ?? true,
      onSuccess: props?.onSuccess,
    },
  );

  return {data, isLoading};
};

export default useGetUserCooperationAgreementData;
